import * as React from 'react';
import { store } from '../../store';
import ProductHero from './sections/ProductHero';
import AppAppBar from './sections/AppAppBar';
import Snackbar from '../../views/landing/components/Snackbar';
import { useState, useEffect, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

// Lazy load below-fold sections for faster initial page load
const RouteScrollAnimation = lazy(() => import('./sections/RouteScrollAnimation'));
const WorkflowAnimations = lazy(() => import('./sections/WorkflowAnimations'));
const TemplateAnimation = lazy(() => import('./sections/TemplateAnimation'));
const ComplexRouteAnimation = lazy(() => import('./sections/ComplexRouteAnimation'));
const WorkflowComparison = lazy(() => import('./sections/WorkflowComparison'));
const DeveloperFriendly = lazy(() => import('./sections/DeveloperFriendly'));
const IndustryUseCases = lazy(() => import('./sections/IndustryUseCases'));
const ProductSmokingHero = lazy(() => import('./sections/ProductSmokingHero'));
const AppFooter = lazy(() => import('./sections/AppFooter'));
import { clearSnackBarMessage, setSnackBarOpen } from '../../store/reducers/snackBarMessages';

function Front() {
    let snackBarOpen = useSelector((state) => state.snackBarMessages.snackBarOpen);
    let [snackBarMessage] = useState(store.getState().snackBarMessages.snackBarMessage);

    const handleSnackBarClose = () => {
        store.dispatch(setSnackBarOpen(false));
        store.dispatch(clearSnackBarMessage());
    };

    useEffect(() => {
        if (snackBarMessage !== '') {
            store.dispatch(setSnackBarOpen(true));
        }
    }, [snackBarMessage]);

    return (
        <React.Fragment>
            <AppAppBar />
            {/* Hero Section - Full screen with CTA */}
            <ProductHero />

            {/* Below-fold sections - lazy loaded for faster initial page load */}
            <Suspense fallback={null}>
                <RouteScrollAnimation />
                <WorkflowAnimations />
                <TemplateAnimation />
                <ComplexRouteAnimation />
                <WorkflowComparison />
                <DeveloperFriendly />
                <IndustryUseCases />
                <ProductSmokingHero />
                <AppFooter />
            </Suspense>

            <Snackbar open={snackBarOpen} closeFunc={handleSnackBarClose} message={snackBarMessage} />
        </React.Fragment>
    );
}

export default Front;
